import { produce } from 'immer'
import { ADD, RESET } from "../types/counter";

const initialState = {
    count: 0
}

const reducer = produce((state = initialState, action) => {
    switch (action.type) {
        case ADD:
            state = { ...state, ...action.payload };
            return state;

        case RESET:
            state.count = 0
            return state;

        default:
            return state
    }
})

export default reducer;